import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { prefetchCollectionsIndex } from "../utils/collectionsData";
import { prefetchPortfolioIndex } from "../utils/portfolioData";
import { prefetchLocationsIndex } from "../utils/locationsData";
import "./PublicNavbar.css";

const LINKS = [
  { to: "/", label: "Home", end: true, prefetch: prefetchPortfolioIndex },
  { to: "/portfolio", label: "Portfolio", prefetch: prefetchPortfolioIndex },
  { to: "/collections", label: "Collections", prefetch: prefetchCollectionsIndex },
  { to: "/locations", label: "Locations", prefetch: prefetchLocationsIndex },
  { to: "/about", label: "About" },
];

export default function PublicNavbar() {
  const [logoFailed, setLogoFailed] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Transparent over the hero at the top of the page; solid + blurred once the
  // reader scrolls, so nav chrome never competes with a full-bleed photograph.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`public-navbar ${scrolled ? "is-scrolled" : ""}`}>
      <Link to="/" className="public-navbar-brand" aria-label="Nature4D home">
        {!logoFailed ? (
          <img
            src="/assets/logo-animated-dark.svg"
            alt="Nature4D"
            className="public-navbar-logo"
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <span className="public-navbar-wordmark">nature4d</span>
        )}
      </Link>

      <nav className="public-navbar-nav" aria-label="Primary">
        <ul className="public-navbar-links">
          {LINKS.map(({ to, label, end, prefetch }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={end}
                className={({ isActive }) =>
                  `public-nav-link ${isActive ? "public-nav-active" : ""}`
                }
                onMouseEnter={prefetch}
                onFocus={prefetch}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
}
